import React, { useState } from 'react'

const ImageWithFallback = ({ 
  src, 
  fallbackSrc, 
  alt, 
  className = '',
  ...props 
}) => {
  const [imgSrc, setImgSrc] = useState(src)
  const [isLoading, setIsLoading] = useState(true)

  // Images par défaut authentiques - SAED + Élevage sénégalais
  const getDefaultImage = (alt) => {
    const altLower = alt.toLowerCase()
    
    if (altLower.includes('rizicole') || altLower.includes('casier') || altLower.includes('riz') || altLower.includes('production')) {
      return 'https://saed.sn/static/assets/images/services/service-1-3.png'
    }
    if (altLower.includes('élevage') || altLower.includes('zébu') || altLower.includes('bovin') || altLower.includes('bétail') || altLower.includes('gobra')) {
      return 'https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    if (altLower.includes('aménagement') || altLower.includes('irrigation') || altLower.includes('hydro')) {
      return 'https://saed.sn/static/assets/images/services/service-2-6.png'
    }
    if (altLower.includes('formation') || altLower.includes('agriculteur') || altLower.includes('familiale')) {
      return 'https://saed.sn/static/assets/images/services/service-2-5.png'
    }
    if (altLower.includes('projet') || altLower.includes('développement') || altLower.includes('3prd')) {
      return 'https://saed.sn/static/assets/images/projects/project-2-6.png'
    }
    if (altLower.includes('atelier') || altLower.includes('plan') || altLower.includes('stratégique') || altLower.includes('saed')) {
      return 'https://saed.sn/static/assets/images/resources/about-1-1.png'
    }
    if (altLower.includes('agro-pasteur') || altLower.includes('pastoralisme') || altLower.includes('transhumance')) {
      return 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    if (altLower.includes('moissonneuse') || altLower.includes('équipement') || altLower.includes('machine') || altLower.includes('génétique')) {
      return 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    if (altLower.includes('transition') || altLower.includes('agroécologique') || altLower.includes('durable') || altLower.includes('climatique')) {
      return 'https://images.unsplash.com/photo-1592419044706-39796d40f98c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    if (altLower.includes('fleuve') || altLower.includes('vallée') || altLower.includes('delta')) {
      return 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    if (altLower.includes('coopérative') || altLower.includes('gie') || altLower.includes('membres')) {
      return 'https://images.unsplash.com/photo-1498579397066-22750a3cb424?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
    
    // Image par défaut - Première image SAED authentique
    return 'https://saed.sn/static/assets/images/services/service-1-3.png'
  }

  const handleError = () => {
    const defaultImg = fallbackSrc || getDefaultImage(alt)
    if (imgSrc !== defaultImg) {
      setImgSrc(defaultImg)
    }
  }

  const handleLoad = () => {
    setIsLoading(false)
  }

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center">
          <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin"></div>
        </div>
      )}
      <img
        src={imgSrc}
        alt={alt}
        onError={handleError}
        onLoad={handleLoad}
        className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'} ${className}`}
        {...props}
      />
    </div>
  )
}

export default ImageWithFallback 